/**
 * Module-wise status enums for listing filters.
 * Values match backend model enums (case-insensitive on API).
 */

const withAll = (options, allLabel = "All Status") => [
  { value: "", label: allLabel },
  ...options,
];

/** UtilityPayment — recharge / BBPS / Fastag / LPG */
export const RECHARGE_STATUS_OPTIONS = withAll([
  { value: "SUCCESS", label: "Success" },
  { value: "PENDING", label: "Pending" },
  { value: "FAILED", label: "Failed" },
]);

/** DMT / Settlement / Add Money — TXN_STATUS */
export const TXN_STATUS_OPTIONS = withAll([
  { value: "SUCCESS", label: "Success" },
  { value: "PENDING", label: "Pending" },
  { value: "INITIATED", label: "Initiated" },
  { value: "FAILED", label: "Failed" },
]);

/** AEPS transactions */
export const AEPS_STATUS_OPTIONS = withAll([
  { value: "SUCCESS", label: "Success" },
  { value: "PENDING", label: "Pending" },
  { value: "FAILED", label: "Failed" },
]);

/** AEPS txn type (optional secondary filter) */
export const AEPS_TXN_TYPE_OPTIONS = withAll(
  [
    { value: "BE", label: "Balance Enquiry" },
    { value: "CW", label: "Cash Withdrawal" },
    { value: "MS", label: "Mini Statement" },
    { value: "AP", label: "Aadhaar Pay" },
    { value: "MF", label: "Money Transfer" },
  ],
  "All Types"
);

/** Wallet / ledger entry status */
export const LEDGER_STATUS_OPTIONS = withAll([
  { value: "SUCCESS", label: "Success" },
  { value: "PENDING", label: "Pending" },
  { value: "INITIATED", label: "Initiated" },
  { value: "FAILED", label: "Failed" },
]);

/** Team fund history — credit / debit side filter */
export const FUND_FLOW_OPTIONS = withAll(
  [
    { value: "credit", label: "Credit" },
    { value: "debit", label: "Debit" },
  ],
  "All Types"
);

/** Team members — isActive flag */
export const TEAM_STATUS_OPTIONS = withAll(
  [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ],
  "All Active"
);

/** Team members — user.model accountStatus enum */
export const TEAM_ACCOUNT_STATUS_OPTIONS = withAll(
  [
    { value: "REGISTERED", label: "Registered" },
    { value: "DOC_UPLOADED", label: "Doc Uploaded" },
    { value: "ONBOARDING_PENDING", label: "Onboarding Pending" },
    { value: "ACTIVE", label: "Active" },
    { value: "SUSPENDED", label: "Suspended" },
    { value: "BLOCKED", label: "Blocked" },
  ],
  "All Account Status"
);

/** Alias map by module key */
export const LISTING_STATUS_BY_MODULE = {
  utility: RECHARGE_STATUS_OPTIONS,
  recharge: RECHARGE_STATUS_OPTIONS,
  bbps: RECHARGE_STATUS_OPTIONS,
  dmt: TXN_STATUS_OPTIONS,
  settlement: TXN_STATUS_OPTIONS,
  addmoney: TXN_STATUS_OPTIONS,
  aeps: AEPS_STATUS_OPTIONS,
  ledger: LEDGER_STATUS_OPTIONS,
  fund: FUND_FLOW_OPTIONS,
  team: TEAM_STATUS_OPTIONS,
  teamAccount: TEAM_ACCOUNT_STATUS_OPTIONS,
};

export default LISTING_STATUS_BY_MODULE;
